export default {
  orderBaseCurrenciesTitle: "العملة الأساسية:",
  avatar: {
    status: "الحالة",
    unverified: "غير مؤكد"
  },
  navigationDrawer: [
    {
      to: "/dashboard",
      tooltip: "لوحة التحكم",
      icon: "$vuetify.CustomIcon.dashboardIcon"
    },
    {
      to: "/main",
      tooltip: "المحفظة",
      icon: "$vuetify.CustomIcon.walletIcon"
    },
    {
      to: "/operations/exchange?from=",
      tooltip: "تبادل سريع",
      icon: "$vuetify.CustomIcon.exchangeIcon"
    },
    // {
    //   to: process.env.VUE_APP_MARKET_BASE_URL,
    //   tooltip: "سوق Excoino",
    //   icon: "$vuetify.CustomIcon.marketLogo",
    //   customLink: true
    // },
    {
      to: `${process.env.VUE_APP_MARKET_BASE_URL}/exchange/v-btc_v-usdt`,
      tooltip: "سوق تجريبي",
      icon: "$vuetify.CustomIcon.demoTrading",
      customLink: true
    },
    {
      to: "/order",
      tooltip: "تسجيل طلب",
      icon: "$vuetify.CustomIcon.newTradeIcon"
    },
    {
      to: "https://hello.excoino.com/fund/",
      tooltip: "استثمار",
      icon: "$vuetify.CustomIcon.investment",
      customLink: true
    },
    {
      to: "/prices",
      tooltip: "أسعار العملات",
      icon: "$vuetify.CustomIcon.priceList"
    },
    {
      to: "/history/transaction",
      tooltip: "تاريخ المعاملات",
      icon: "$vuetify.CustomIcon.orderHistoryIcon"
    },
    {
      to: "/gifts",
      tooltip: "الهدايا",
      icon: "$vuetify.CustomIcon.giftIcon"
    },
    {
      to: "/referral",
      tooltip: "دعوة الأصدقاء",
      icon: "$vuetify.CustomIcon.referral"
    },
    {
      to: "/tickets",
      tooltip: "دعم التذاكر",
      icon: "$vuetify.CustomIcon.supportIcon"
    }
  ],
  market: {
    tooltip: "سوق Excoino"
  },
  exit: {
    tooltip: "تسجيل الخروج"
  },
  changeTheme: {
    tooltip: "تغيير لون السمة"
  }
};
